import { observable, flow, makeObservable } from 'mobx';
import { LoanTermsService } from '@roc/feature-loan-fasttrack';
import { ApiResponse, GlobalStore } from '@roc/feature-app-core';

export class TamariskPaymentsStore {
  private globalStore: GlobalStore;
  private loanTermsService: LoanTermsService;
  amcPaymentLink = "";

  constructor(globalStore) {
    this.globalStore = globalStore;
    this.loanTermsService = new LoanTermsService();
    makeObservable(this, {
      amcPaymentLink: observable,
      fetchPaymentLink: flow,
    });
  }

  *fetchPaymentLink(loanId: string){
    // Never keep a payment link from a previous loan in the iframe
    this.amcPaymentLink = "";
    try {
      const response: ApiResponse = yield this.loanTermsService.getAmcPayment(loanId);

      const { data } = response.data;

      this.amcPaymentLink = data ? data : null;
      console.log("AMCPAYMENT LINK:", this.amcPaymentLink);
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error while getting amc payment link',
      });
    }
  }
}

export default TamariskPaymentsStore;
